export default __webpack_public_path__ + "static/media/feature-email-home.610bff5b.svg";